import { apiGet, apiPost } from '@/lib/api-client';
import type {
  GetWidgetColorsResponse,
  SaveWidgetColorsRequest,
  SaveWidgetColorsResponse,
} from '@shared/types/dashboard';

export const getWidgetColors = async (shop: string): Promise<GetWidgetColorsResponse> => {
  const response = await apiGet<GetWidgetColorsResponse>(`/api/widget/colors?shop=${encodeURIComponent(shop)}`);
  return response.data || response as GetWidgetColorsResponse;
};

export const saveWidgetColors = async (request: SaveWidgetColorsRequest): Promise<SaveWidgetColorsResponse> => {
  const response = await apiPost<SaveWidgetColorsResponse>('/api/widget/colors', request);
  return response.data || response as SaveWidgetColorsResponse;
};

